import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHondaComponent } from './simple-icons-honda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHondaComponent ],
    exports:      [ SimpleIconsHondaComponent ],
    bootstrap:    []
})
export class SimpleIconsHondaModule {}
